import { IComponentOptions } from "angular";
import { MachineTypeIdInfoMachineComponentController } from "./controller";

export const vsComponentName = "machineTypeIdInfoMachinesComponent";

export const machineTypeIdInfoMachineComponentOptions: IComponentOptions = {
  controller: MachineTypeIdInfoMachineComponentController,
  controllerAs: "typeIdMachineController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    typeId: "<",
  },
};
